'use client'
import { useState } from 'react'

interface SwitchProps {
  left: string
  right: string
  className?: string
  onChange?: (checked: boolean) => void
}

export function Switch({ left, right, className, onChange }: SwitchProps) {
  const [isChecked, setIsChecked] = useState(false)

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked)
    if (onChange) {
      onChange(!isChecked)
    }
  }

  return (
    <div
      className={`relative inline-flex cursor-pointer items-center truncate rounded-full bg-[#F4F4F5] p-1 font-darkergrotesque text-lg font-semibold ${className}`}
      onClick={handleCheckboxChange}
    >
      <span
        className={`flex h-[28px] w-1/2 items-center justify-center rounded-full px-3 pb-[6.5px] pt-1 transition-colors duration-200 ${!isChecked ? 'bg-white text-zinc-950 shadow-custom' : 'text-zinc-500'}`}
      >
        {left}
      </span>
      <span
        className={`flex h-[28px] w-1/2 items-center justify-center rounded-full px-3 pb-[6.5px] pt-1 transition-colors duration-200 ${isChecked ? 'bg-white text-zinc-950 shadow-custom' : 'text-zinc-500'}`}
      >
        {right}
      </span>
    </div>
  )
}
